import { FC } from "react";
import { Box, styled } from "@mui/system";
import { H1, H4 } from "../../../components/Typography";
import { CardContainer } from "../../../components/CardContainer";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import { GullButton } from "../../../components/buttons/GullButton";
import useCommonContext from "../../../hooks/useCommonContext";
import CustomerFormModal from "../../../components/modals/CustomerFormModal";

const StyledImg = styled("img")(() => ({
  width: "200px",
  marginTop: "50px",
}));

const AddCustomer: FC = () => {
  const { setFormModal } = useCommonContext();

  return (
    <>
      <Breadcrumb
        name="Customers"
        subName="Add Customer"
        path="/dashboard/v1"
      />

      <CardContainer
        sx={{
          height: "600px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box textAlign="center">
          <H1 color="primary.main">Welcome</H1>
          <H4 sx={{ color: "grey.main", py: "20px" }}>
            No customer added yei <br /> Click the button and add new customer
          </H4>
          <GullButton
            variant="contained"
            color="primary"
            sx={{ p: ".5rem 1.2rem", fontWeight: "bold" }}
            onClick={() => setFormModal(true)}
          >
            Add Customer
          </GullButton>
        </Box>
        <StyledImg src="/assets/images/documents.png" alt="" />
        <CustomerFormModal />
      </CardContainer>
    </>
  );
};

export default AddCustomer;
